import {
  calculateSiding,
  calculateCornerTrim,
  calculateWindowTopAndBottom,
  calculateWindowSides,
  calculateDoorLintel,
  calculateDoorEdgeSides,
  calculateBottomPlates,
  calculateCornerStuds,
  calculateBirdBlocks,
  calculateRafters,
  calculateRafterPlates,
  calculateCasementWindowSides,
  calculateRafterPallet,
  calculateRafterTrim,
  calculateHeaders,
} from "./calculations";

const useMaterials = (walls, yurtTrait) => {
  const materials = [
    ...calculateSiding(walls, yurtTrait),

    ...calculateCornerTrim(walls, yurtTrait),
    ...calculateWindowTopAndBottom(walls, yurtTrait),
    ...calculateDoorLintel(walls),
    ...calculateDoorEdgeSides(walls),
    ...calculateCasementWindowSides(walls, yurtTrait),
    ...calculateWindowSides(walls, yurtTrait),

    ...calculateCornerStuds(walls, yurtTrait),
    ...calculateHeaders(walls, yurtTrait),
    ...calculateBirdBlocks(walls, yurtTrait),
    ...calculateRafterPlates(walls, yurtTrait),
    ...calculateBottomPlates(walls, yurtTrait),

    ...calculateRafters(walls, yurtTrait),
    ...calculateRafterPallet(walls, yurtTrait),
    ...calculateRafterTrim(walls, yurtTrait),
  ];

  return materials;
};

export default useMaterials;
